// extracted by mini-css-extract-plugin
module.exports = {"select":"_2CaAA2XLEE6-aMj24X0G8s"};